import { StarFill, StarHalfFill, StarNoFill } from '../assets'
import styles from './star-rating.module.css'

export interface StarRatingProps {
  starRating: number
}

export const StarRating: React.FC<StarRatingProps> = ({ starRating }) => {
  const stars = [...Array.from({ length: 5 }).keys()]

  const starComponents: JSX.Element[] = stars.map((_, index) => {
    const isHalfStar = starRating % 2 !== 0 || Number.isInteger(starRating / 2)
    const starNumber = index + 1
    const idPrefix = `star-${starRating}-${starNumber}`

    return starNumber <= starRating / 2 ? (
      <StarFill key={`starRating-${starNumber}`} />
    ) : isHalfStar && starNumber === Math.ceil(starRating / 2) ? (
      <StarHalfFill key={`starRating-${starNumber}`} idPrefix={idPrefix} />
    ) : (
      <StarNoFill key={`starRating-${starNumber}`} />
    )
  })

  return <div className={styles.starRatingContainer}>{starComponents}</div>
}

export default StarRating
